<template>
  <v-container id="axis-list">
    <v-row>
      <v-col cols="12" md="12" class="breadcrumbs">
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="8" offset-sm="4">
        <div class="text-right">
          <div cols="10" md="1">
            <app-modal-import-group-solution
              :color="'success'"
              :icon="'mdi-plus-circle'"
              @onSave="loadAxis()"
            >
              <template v-slot:title> Importação de Grupo de Solução </template>
            </app-modal-import-group-solution>

            <app-modal-insert-axis
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              @onSave="loadAxis()"
            >
              <template v-slot:title>
                Cadastramento de Grupo de Solução
              </template>
            </app-modal-insert-axis>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="axisActive"
          item-key="name"
          class="elevation-1"
          :loading="loading"
          loading-text="Carregando ..."
        >
          <template v-slot:item.acoes="{ item }">
            <v-row>
              <v-col cols="1">
                <app-modal-insert-axis
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  @onSave="loadAxis"
                >
                  <template v-slot:title> Edição de Grupo de Solução </template>
                </app-modal-insert-axis>
              </v-col>

              <v-col cols="1" class="col-min-width-bigger">
                <app-modal-delete-axis :payload="item" @onDelete="loadAxis">
                  <template v-slot:title> Deletar Grupo de Solução </template>
                </app-modal-delete-axis>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <AppRetrieveGroupSolution
          :solutionsGroup="desactivatedAxis"
          @onRecover="loadAxis"
        >
        </AppRetrieveGroupSolution>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { cityGroupSolutionAPI } from "@/modules/city/API/CityGroupSolutionAPI";
import AppModalInsertAxis from "./ModalInsert";
import AppModalImportGroupSolution from "@/modules/group-solution/components/city/ModalImport";
import AppModalDeleteAxis from "./ModalDelete";
import AppRetrieveGroupSolution from "./RetrieveSolutionGroup";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppAxisList",
  props: {
    filter: { type: Object, required: true },
  },
  components: {
    AppModalInsertAxis,
    AppModalImportGroupSolution,
    AppModalDeleteAxis,
    AppRetrieveGroupSolution,
  },
  data() {
    return {
      headers: [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ],
      axisActive: [],
      allAxisActive: [],
      allDesactivatedAxis: [],
      desactivatedAxis: [],
      breadcrumbs: [
        {
          text: "Grupos de Soluções",
          disabled: true,
          href: "eixo",
        },
      ],
    };
  },
  mounted() {
    this.loadAxis();
  },
  watch: {
    filter: {
      handler(value) {
        if (value.municipioGrupoSolucao.municipioGrupoSolucaoId) {
          this.axisActive = this.allAxisActive.filter(
            (item) =>
              item.municipioGrupoSolucaoId ===
              value.municipioGrupoSolucao.municipioGrupoSolucaoId
          );
          this.desactivatedAxis = this.allDesactivatedAxis.filter(
            (item) =>
              item.municipioGrupoSolucaoId ===
              value.municipioGrupoSolucao.municipioGrupoSolucaoId
          );
        } else {
          this.axisActive = this.allAxisActive;
          this.desactivatedAxis = this.allDesactivatedAxis;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["loading", "isFullAdmin"]),
  },
  methods: {
    ...mapActions(["setLoading", "reload"]),
    loadAxis() {
      this.setLoading(true);
      cityGroupSolutionAPI
        .listByCity(this.$route.params.id)
        .then((resp) => {
          this.allAxisActive = resp.data.filter((item) => !item.desabilitado);
          this.allDesactivatedAxis = resp.data.filter(
            (item) => item.desabilitado
          );
          this.axisActive = resp.data.filter((item) => !item.desabilitado);
          this.desactivatedAxis = resp.data.filter((item) => item.desabilitado);
          this.reload(["groups", "solutions", "tasks"]);
          this.$emit("reloadGroup");
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao listar grupos de soluções");
        });
    },
  },
};
</script>

<style lang="scss">
@import "./../style.scss";
</style>
